// DetectMode.js
/**
 * Simple heuristic function to detect whether the input is a question (AI Q&A) or a statement/claim.
 * Returns one of: 'ai', 'claim', or 'unknown'.
 */
export function detectInputMode(userInput) {
    const text = userInput.trim().toLowerCase();
  
    // Heuristic 1: If the text ends with a question mark, assume AI Q&A.
    if (text.endsWith('?')) {
      return 'ai';
    }
  
    // Heuristic 2: If the text starts with a typical question word, assume AI Q&A.
    const questionWords = ['who', 'what', 'where', 'when', 'why', 'how'];
    const firstWord = text.split(/\s+/)[0];
    if (questionWords.includes(firstWord)) {
      return 'ai';
    }
  
    // Heuristic 3: If the text contains any claim-check specific phrases, return 'claim'.
    const claimIndicators = [
      'is this possible',
      'can this be true',
      'kinda sounds like',
      'kinda',
      'maybe',
      'confirm',
      'can you confirm'
    ];
    for (const phrase of claimIndicators) {
      if (text.includes(phrase)) {
        return 'claim';
      }
    }
  
    // If no indicators for either AI or claim, return 'unknown'
    return 'unknown';
  }
  